import {connect} from "react-redux";
import {reset, getFormValues} from 'redux-form';
import {
  GET_PROGRAMS_LIST,
  GET_REFERRALOUTCOME_LIST,
  GET_BOPINSTITUTIONS_LIST,
  GET_DRUGAFTERCAREPROGRAMS_LIST,
  GET_GANGAFFILIATIONS_LIST,
  GET_REFERRALSOURCE_LIST,
                                                  // GET_BHTsINSURANCEPROVIDERS_LIST,
} from '../actions/action-constants';
import {
  getDropDownsList
} from '../actions/actions-drop-downs';
import {
  getPostDischarge, 
  updatePostDischargeSave,
  updatePostDischargeSaveAndClose,
} from '../actions/actions-postdischarges';
import {
  archivePostDischarge
} from '../actions/actions-archived-postdischarges';
import PostDischargeEditRoot from '../components/edit-view-postdischarge/postdischarge-container-root-edit';
const mapStateToProps = (state, ownProps) => {
  return {
    parentProps: ownProps,
    initialValues: state.postdischargesR.dataEntry,
                                                    currentFormState: getFormValues('PostDischargeEditForm')(state),    
    programsList: state.programsR,
    referralOutcomesList: state.referraloutcomesR,
                                                        // bhtsinsuranceprovidersList: state.bhtsinsuranceprovidersR,
    // bopinstitutionsList: state.bopinstitutionsR,
    // gangaffiliationsList: state.gangaffiliationsR,
    // referralsourcesList: state.referralsourcesR,
    bopinstitutionsList: state.bopinstitutionsR.bopinstitutions,
    gangaffiliationsList: state.gangaffiliationsR.gangaffiliations,
    referralsourcesList: state.referralsourcesR.referralsources,
    loadingList: state.postdischargesR.loadingList,
    errorInvalidEntry: state.postdischargesR.errorInvalidEntry,
  };
};
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getPostDischarge: (id) => {
      dispatch(getPostDischarge(id) );},

    getPrograms: (params) => {
      dispatch(getDropDownsList( params, GET_PROGRAMS_LIST) );},  
    getReferralOutcomes: (params) => {
      dispatch(getDropDownsList( params, GET_REFERRALOUTCOME_LIST) );},
                                                        // getBHTsInsuranceProviders: (params) => {
                                                        //   dispatch(getDropDownsList( params, GET_BHTsINSURANCEPROVIDERS_LIST) );},
    getBOPInstitutions: (params) => {
      dispatch(getDropDownsList( params, GET_BOPINSTITUTIONS_LIST) );},
    getDrugAftercarePrograms: (params) => {
      dispatch(getDropDownsList( params, GET_DRUGAFTERCAREPROGRAMS_LIST) );},
    getGangAffiliations: (params) => {
      dispatch(getDropDownsList( params, GET_GANGAFFILIATIONS_LIST) );},
    getReferralSources: (params) => {
      dispatch(getDropDownsList( params, GET_REFERRALSOURCE_LIST) );},

    updatePostDischargeSave: (id, postdischargeEntry) => {
      dispatch(updatePostDischargeSave(id, postdischargeEntry) )
      ; },
    updatePostDischargeSaveAndClose: (id, postdischargeEntry) => {
      dispatch(updatePostDischargeSaveAndClose(id, postdischargeEntry) )
        .then(() => dispatch(reset('PostDischargeEditForm')) )
        .then(() => ownProps.history.push('/postdischarges') )  
      ; },
    archivePostDischarge: (id, postdischargeEntry) => {
      dispatch(archivePostDischarge(id, postdischargeEntry) )
        .then(() => dispatch(reset('PostDischargeEditForm')) )
        .then(() => ownProps.history.push('/postdischarges') )  
      ;},

  };
};
const PostDischargeEditContainer = connect(mapStateToProps, mapDispatchToProps)(PostDischargeEditRoot);
export default PostDischargeEditContainer;